import { useEffect, useRef } from "react";

import Mixpanel from "mixpanel-browser";

class Analytics {
  static mixpanel = Mixpanel;

  public static init = async () => {
    await Mixpanel.init("eb87b138bbb5d556fcf53bebac24b935");
  };

  public static identify = (id: string) => {
    Mixpanel.identify(id);
  };

  public static track = (message: string, property: any = null) => {
    if (property === null) {
      return Mixpanel.track(message);
    } else {
      return Mixpanel.track(message, property);
    }
  };

  public static group = (id: string, property: string) => {
    Mixpanel.add_group(id, property);
  };
}

export default Analytics;
